import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Table } from "antd";
import formatError from "../../services/FormatError";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import { sortList } from "./Users";
import { dateFormatter } from "./BuyerProfile";
import {
  addSellerProfile,
  deleteSellerProfile,
  fetchAllSellers,
  fetchSellerDetails,
} from "../../services/SellerService";
import { useTranslation } from "react-i18next";
// Select removed: no longer using debt type dropdown
import swal from "sweetalert";
import { getBase64 } from "./Registration";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";
import { MultiSelect } from "react-multi-select-component";

const libraries = ["places"];

export const validateSeller = (data) => {
  const isNonEmpty = (val) => val !== "" && val !== null && val !== undefined;
  const isNonNegativeNumber = (val) => {
    if (!isNonEmpty(val)) return false;
    const num = Number(val);
    return !Number.isNaN(num) && num >= 0;
  };
  const funding = data?.funding_rounds || {};

  if (
    isNonEmpty(data?.name) &&
    isNonEmpty(data?.contactName) &&
    isNonEmpty(data?.contactEmail) &&
    isNonEmpty(data?.email) &&
    isNonEmpty(data?.phone) &&
    isNonEmpty(data?.occupation) &&
    isNonEmpty(data?.country) &&
    isNonEmpty(data?.domain) &&
    isNonNegativeNumber(data?.short_term_debt_amount) &&
    isNonNegativeNumber(data?.long_term_debt_amount) &&
    isNonNegativeNumber(funding?.seed) &&
    isNonNegativeNumber(funding?.a) &&
    isNonNegativeNumber(funding?.b) &&
    isNonNegativeNumber(funding?.c)
  ) {
    return false;
  } else {
    return true;
  }
};

function CreateSeller() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyB3n919-1MbNDn_jkTYcM0v4wVCoAWxRA0",
    libraries,
  });
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const { t } = useTranslation();
  const role = userDetails?.result;

  const state = useSelector((state) => state.auth.auth.result);

  const navigate = useNavigate();

  const location = useLocation();

  const dispatch = useDispatch();

  // inside component state:
  const [ownershipType, setOwnershipType] = useState("single");
  const [partners, setPartners] = useState([
    { partner_name: "", partner_email: "", partnership_percentage: 0 },
  ]);
  const [loan, setLoan] = useState(false);
  const [loanDetails, setLoanDetails] = useState({
    institution: "",
    balance: "",
  });
  const [equity, setEquity] = useState("");
  const [creditor, setCreditor] = useState("");
  const [shortTermDebtAmount, setShortTermDebtAmount] = useState("");
  const [longTermDebtAmount, setLongTermDebtAmount] = useState("");
  const [fundingRounds, setFundingRounds] = useState({
    seed: "",
    a: "",
    b: "",
    c: "",
  });

  // add partner handler
  const addPartner = () => {
    setPartners([
      ...partners,
      { partner_name: "", partner_email: "", partnership_percentage: 0 },
    ]);
  };

  const updatePartner = (index, key, value) => {
    const updated = [...partners];
    if (key === "partnership_percentage") {
      updated[index][key] = value === "" ? "" : parseFloat(value) || 0;
    } else {
      updated[index][key] = value;
    }
    setPartners(updated);
  };

  // validation: total %
  const totalOwnership = partners.reduce(
    (sum, p) => sum + Number(p.partnership_percentage || 0),
    0
  );

  const removePartner = (idx) => {
    setPartners((prev) => prev.filter((_, i) => i !== idx));
  };

  const financingOptions = [
    { value: "seed", label: "Seed" },
    { value: "a", label: "Series A" },
    { value: "b", label: "Series B" },
    { value: "c", label: "Series C" },
  ];
  const [professions, setProfessions] = useState([]);
  const [sellerProfiles, setSellerProfiles] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, setGridFilter] = useState("");

  const [addSeller, setAddSeller] = useState(true);

  const [triggered, setTriggered] = useState(false);

  const [sellerDetails, setSellerDetails] = useState({
    name: "",
    contactName: "",
    contactEmail: "",
    email: "",
    phone: "",
    phone2: "",
    fax: "",
    occupation: "",
    address: "",
    city: "",
    postalCode: "",
    country: "",
    region: "",
    domain: "",
    website: "",
    ownership_type: "single",
    has_loan: false,
    loan_details: {
      institution: "",
      balance: "",
    },
    equity: "",
    creditor: "",
    partners: [
      { partner_name: "", partner_email: "", partnership_percentage: 0 },
    ],
    short_term_debt_amount: "",
    long_term_debt_amount: "",
    funding_rounds: { seed: "", a: "", b: "", c: "" },
    need_professionals: "",
  });

  const [updateSeller, setUpdateSeller] = useState({
    cond: false,
    id: null,
  });

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const fileInputRef = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const [base64, setBase64] = useState("");

  useEffect(() => {
    if (location?.state === true) {
      onCreateSeller();
    }
  }, [location?.state]);

  useEffect(() => {
    fetchAllSellerProfiles();
  }, [state, tableParams.current, tableParams.pageSize]);

  const fetchAllSellerProfiles = async () => {
    if (role?.role?.id !== 3) {
      fetchAllSellers(tableParams.current, tableParams.pageSize)
        .then((res) => {
          const response = res.data?.result;

          const sortedList = sortList(response?.data ?? []);

          setSellerProfiles({
            original: [...sortedList],
            filtered: [...sortedList],
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      if (role?.user?.sellerprofile?.id === 0) {
        setSellerProfiles({
          original: [],
          filtered: [],
        });
      } else {
        const sellerId = role?.user?.sellerprofile?.id ?? null;
        if (sellerId) {
          fetchSellerDetails(sellerId)
            .then((res) => {
              const data = res.data?.result;

              setSellerProfiles({
                original: [data],
                filtered: [data],
              });
            })
            .catch((error) => {
              formatError(error?.response?.data?.error);
            });
        }
      }

      setTableParams((prevTableParams) => ({
        ...prevTableParams,
        total: 1,
      }));
    }
  };

  const updateGridData = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const filteredData = sellerProfiles.original.filter((item) =>
        item?.name.toLowerCase().includes(value.toLowerCase())
      );

      setSellerProfiles((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setSellerProfiles((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const onCreateSeller = () => {
    setAddSeller(true);

    setSellerDetails({
      name: "",
      contactName: role?.user?.firstname + " " + role?.user?.lastname,
      contactEmail: role?.user?.email,
      email: "",
      phone: role?.user?.phone,
      phone2: "",
      fax: "",
      occupation: "",
      address: role?.user?.address,
      city: role?.user?.city,
      postalCode: "",
      country: role?.user?.country,
      region: "",
      domain: "",
      website: "",
      ownership_type: "single",
      has_loan: false,
      loan_details: {
        institution: "",
        balance: "",
      },
      equity: "",
      creditor: "",
      partners: [
        { partner_name: "", partner_email: "", partnership_percentage: 0 },
      ],
      short_term_debt_amount: "",
      long_term_debt_amount: "",
      funding_rounds: { seed: "", a: "", b: "", c: "" },
      need_professionals: "",
    });
  };
  useEffect(() => {
    onCreateSeller();
  }, []);
  const updateSellerDetails = (key, value) => {
    setSellerDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  useEffect(() => {
    setSellerDetails((prevState) => ({
      ...prevState,
      ownership_type: ownershipType,
      has_loan: loan,
      loan_details: loanDetails,
      equity: equity,
      creditor: creditor,
      short_term_debt_amount: shortTermDebtAmount,
      long_term_debt_amount: longTermDebtAmount,
      funding_rounds: fundingRounds,

      partners: partners,
    }));
  }, [
    partners,
    ownershipType,
    loan,
    loanDetails,
    equity,
    creditor,
    shortTermDebtAmount,
    longTermDebtAmount,
    fundingRounds,
  ]);
  const addSellerHandler = (id) => {
    if (validateSeller(sellerDetails)) {
      setTriggered(true);
    } else {
      setTriggered(false);
      setTriggered(false);
      sellerDetails["professional_required"] = professions.map(
        (item) => item.value
      );
      addSellerProfile(sellerDetails, id)
        .then((res) => {
          setSellerDetails({
            name: "",
            contactName: "",
            contactEmail: "",
            email: "",
            phone: "",
            phone2: "",
            fax: "",
            occupation: "",
            address: "",
            city: "",
            postalCode: "",
            country: "",
            region: "",
            domain: "",
            website: "",
            ownership_type: "single",
            has_loan: false,
            loan_details: {
              institution: "",
              balance: "",
            },
            equity: "",
            creditor: "",
            partners: [
              {
                partner_name: "",
                partner_email: "",
                partnership_percentage: 0,
              },
            ],
            short_term_debt_amount: "",
            long_term_debt_amount: "",
            funding_rounds: { seed: "", a: "", b: "", c: "" },
            need_professionals: "",
          });

          if (updateSeller.cond) {
            setUpdateSeller({
              cond: false,
              id: null,
            });
          }

          const newSessionDetails = { ...userDetails };

          newSessionDetails.result.user.sellerprofile = res?.data?.result;

          sessionStorage.setItem(
            "userDetails",
            JSON.stringify(newSessionDetails)
          );

          dispatch(loginConfirmedAction(newSessionDetails));
          setAddSeller(false);
          navigate("/seller");
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };

  // address autocomplete
  const searchBoxRef = useRef(null);

  const [addressInput, setAddressInput] = useState(
    sellerDetails?.address || ""
  );

  const handlePlacesChanged = () => {
    console.log(searchBoxRef.current, "adresse");
    if (!searchBoxRef.current) return; //

    updateSellerDetails("address", "");
    updateSellerDetails("city", "");
    updateSellerDetails("region", "");
    updateSellerDetails("postalCode", "");
    updateSellerDetails("country", "");
    setAddressInput("");
    const places = searchBoxRef.current.getPlaces();
    if (places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      let address = "";
      let streetNumber = "";
      let route = "";
      let city = "";
      let region = "";
      let postalCode = "";
      let country = "";

      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes("street_number")) {
          address = component.long_name;
        }
        if (types.includes("route")) {
          address = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          region = component.long_name;
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      });
      console.log(address, "adresse");

      setAddressInput(address); // met à jour l'input
      updateSellerDetails("address", address); // met à jour le state global

      //  updateBusinessDetails("address", address);
      updateSellerDetails("city", city);
      updateSellerDetails("region", region);
      updateSellerDetails("postalCode", postalCode);
      updateSellerDetails("country", country);
    }
  };
  // End address autocomplete

  const onBackCreate = () => {
    setSellerDetails({
      name: "",
      contactName: "",
      contactEmail: "",
      email: "",
      phone: "",
      phone2: "",
      fax: "",
      occupation: "",
      address: "",
      city: "",
      postalCode: "",
      country: "",
      region: "",
      domain: "",
      website: "",
    });
  };

  const onViewSeller = (id) => {
    navigate(`/seller/${id}`);
  };

  const onUpdateSeller = (id) => {
    fetchSellerDetails(id)
      .then((res) => {
        const data = res.data?.result;

        setUpdateSeller({
          cond: true,
          id: data?.id,
        });

        setAddSeller(true);

        // Populate overarching sellerDetails object (used for submission)
        setSellerDetails({
          name: data?.name,
          contactName: data?.contactname,
          contactEmail: data?.contactemail,
          email: data?.email,
          phone: data?.phone,
          phone2: data?.phone2,
          fax: data?.fax,
          occupation: data?.occupation,
          address: data?.address,
          city: data?.city,
          postalCode: data?.postalcode,
          country: data?.country,
          region: data?.region,
          domain: data?.domain,
          website: data?.website,
          ownership_type: data?.ownership_type,
          has_loan: data?.has_loan,
          loan_details: data?.loan_details,
          equity: data?.equity,
          creditor: data?.creditor,
          partners: data?.partners,
          need_professionals: data?.need_professionals,
          short_term_debt_amount: data?.short_term_debt_amount,
          long_term_debt_amount: data?.long_term_debt_amount,
          funding_rounds: {
            seed: data?.funding_rounds?.seed ?? "",
            a: data?.funding_rounds?.a ?? "",
            b: data?.funding_rounds?.b ?? "",
            c: data?.funding_rounds?.c ?? "",
          },
        });

        // Populate local UI states so inputs reflect existing values
        setOwnershipType(data?.ownership_type ?? "single");
        setLoan(Boolean(data?.has_loan));
        setLoanDetails({
          institution: data?.loan_details?.institution ?? "",
          balance: data?.loan_details?.balance ?? "",
        });
        setEquity(data?.equity ?? "");
        setCreditor(data?.creditor ?? "");
        setPartners(
          Array.isArray(data?.partners)
            ? data.partners.map((p) => ({
                partner_name: p?.partner_name ?? "",
                partner_email: p?.partner_email ?? "",
                partnership_percentage:
                  p?.partnership_percentage === "" ||
                  p?.partnership_percentage == null
                    ? 0
                    : Number(p?.partnership_percentage),
              }))
            : [
                {
                  partner_name: "",
                  partner_email: "",
                  partnership_percentage: 0,
                },
              ]
        );
        setShortTermDebtAmount(
          data?.short_term_debt_amount === null
            ? ""
            : data?.short_term_debt_amount ?? ""
        );
        setLongTermDebtAmount(
          data?.long_term_debt_amount === null
            ? ""
            : data?.long_term_debt_amount ?? ""
        );
        setFundingRounds({
          seed:
            data?.funding_rounds?.seed === null
              ? ""
              : data?.funding_rounds?.seed ?? "",
          a:
            data?.funding_rounds?.a === null
              ? ""
              : data?.funding_rounds?.a ?? "",
          b:
            data?.funding_rounds?.b === null
              ? ""
              : data?.funding_rounds?.b ?? "",
          c:
            data?.funding_rounds?.c === null
              ? ""
              : data?.funding_rounds?.c ?? "",
        });
      })
      .catch((error) => {
        formatError(error?.response?.data?.error);
      });
  };

  const onDeleteSeller = (id) => {
    swal({
      title: t("are_you_sure"),
      text: t("honceDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteSellerProfile(id)
          .then((res) => {
            swal(t("hsellerdelete"), "", "success");
            fetchAllSellerProfiles();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };

  const onChangePhoto = async (e) => {
    const file = e.target.files[0];

    const sizeLimit = 2 * 1024 * 1024; // 2MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", t("hmaxFile"), "error", {
          button: t("htry"),
        });

        fileInputRef.current.value = "";
        setSelectedFile(null);

        setBase64("");

        return;
      }

      // Check if the selected file is of type jpg or png
      if (fileType === "image/jpeg" || fileType === "image/png") {
        const base64String = await getBase64(file);

        setSelectedFile(file);
        setBase64(base64String);
      } else {
        fileInputRef.current.value = "";

        setSelectedFile(null);
        setBase64("");

        swal("Oops", t("hselectJpg"), "error", {
          button: t("htry"),
        });
      }
    }
  };

  const columns = [
    {
      title: `${t("sellerProfileCulumn1")}`,
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: `${t("sellerProfileCulumn2")}`,
      dataIndex: "name",
      sorter: true,
      render: (text, record) => {
        return (
          <>
            <span>{text}</span>
            <br />
            <span>{record?.contactemail}</span>
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn3")}`,
      dataIndex: "country",
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn4")}`,
      dataIndex: "createdat",
      render: (text) => dateFormatter(text),
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn5")}`,
      dataIndex: "domain",
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn6")}`,
      dataIndex: "occupation",
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn7")}`,
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              style={{ fontSize: "15px", marginRight: "8px" }}
              onClick={() => onViewSeller(record?.id)}
            >
              <i className="fa fa-eye"></i>
            </a>
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              onClick={() => onUpdateSeller(record?.id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
            {(role?.role?.id === 1 || role?.role?.id === 2) && (
              <a
                href="javascript:void(0);"
                class="ms-2 btn btn-xs px-2 light btn-danger"
                style={{ marginRight: "8px" }}
                onClick={() => onDeleteSeller(record?.id)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 6H5H21"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </a>
            )}
          </div>
        );
      },
      width: "20%",
    },
  ];

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      <div class="card">
        <div class="card-header d-sm-flex d-block">
          {addSeller ? (
            <div class="d-flex me-auto mb-sm-0">
              <h4
                class="card-title"
                style={{ textTransform: "uppercase", fontWeight: "bold" }}
              >
                {updateSeller?.cond ? t("update") : t("globalCreateButton")}{" "}
                {t("sellerProfileTitle2")}
              </h4>
            </div>
          ) : (
            <>
              <div class="d-flex me-auto mb-sm-0">
                <h4 class="card-title">
                  {t("sellerProfileTitle2")}
                  {role?.role?.id !== 3 ? "S" : ""}
                </h4>
              </div>
              <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
              {role?.role?.id === 3 && role?.user?.sellerprofile && (
                <div style={{ paddingLeft: "12px", fontWeight: "bold" }}>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-info"
                    onClick={onCreateSeller}
                  >
                    {" "}
                    + {t("sellerProfileCreateButton")}
                  </a>
                </div>
              )}
            </>
          )}
        </div>

        {!addSeller && (
          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={sellerProfiles.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        )}
      </div>

      {addSeller && (
        <div className="row overflow-y-scroll">
          <div className="mb-3 shadow-sm">
            <div
              className="h4"
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginTop: "30px",
                paddingTop: "10px",
                backgroundColor: "#310247",
              }}
            >
              <h4 style={{ color: "#ffffffff", marginLeft: "10px" }}>
                {t("hinfosGeneral")}
              </h4>
              <hr />
            </div>
            <div className="card-body p-0">
              <div className="row">
                <div className="col-md-4 col-sm-12 col-xl-4">
                  <div
                    className={`form-group ${
                      triggered && sellerDetails?.name === "" ? "mb-1" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      {" "}
                      <strong>{t("nameInput")}</strong>
                      <span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      type="text"
                      placeholder={t("nameInput")}
                      className="form-control"
                      value={sellerDetails?.name}
                      onChange={(e) =>
                        updateSellerDetails("name", e.target.value)
                      }
                    />
                  </div>
                  {triggered && sellerDetails?.name === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {" "}
                      {t("nameInput")} {t("globalIsRequired")}{" "}
                    </div>
                  )}
                </div>

                <div className="col-md-4 col-sm-12 col-xl-4">
                  <div
                    className={`form-group ${
                      triggered && sellerDetails?.email === "" ? "mb-1" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("emailInput")}</strong>
                      <span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      type="email"
                      placeholder={t("emailInput")}
                      className="form-control"
                      value={sellerDetails?.email}
                      onChange={(e) =>
                        updateSellerDetails("email", e.target.value)
                      }
                    />
                  </div>
                  {triggered && sellerDetails?.email === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("emailInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>

                <div className="col-md-4 col-sm-12 col-xl-4">
                  <div
                    className={`form-group ${
                      triggered && sellerDetails?.phone === "" ? "mb-1" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("phoneInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder={t("phoneInput")}
                      className="form-control"
                      value={sellerDetails?.phone}
                      onChange={(e) =>
                        updateSellerDetails("phone", e.target.value)
                      }
                    />
                  </div>
                  {triggered && sellerDetails?.phone === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("phoneInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 col-sm-12 col-xl-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("faxInput")}</strong>
                  </label>
                  <input
                    type="number"
                    placeholder={t("faxInput")}
                    className="form-control"
                    value={sellerDetails?.fax}
                    onChange={(e) => updateSellerDetails("fax", e.target.value)}
                  />
                </div>
              </div>

              <div className="col-sm-12 col-md-4 col-xl-4">
                <div
                  className={`form-group ${
                    triggered && sellerDetails?.domain === "" ? "" : "mb-3"
                  }`}
                >
                  <label className="mb-1">
                    <strong>{t("domainInput")}</strong>{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t("domainInput")}
                    className="form-control"
                    value={sellerDetails?.domain}
                    onChange={(e) =>
                      updateSellerDetails("domain", e.target.value)
                    }
                  />
                </div>
                {triggered && sellerDetails?.domain === "" && (
                  <div className="text-danger fs-12 mb-3">
                    {t("domainInput")} {t("globalIsRequired")}
                  </div>
                )}
              </div>

              <div className="col-sm-12 col-md-4 col-xl-4">
                <div
                  className={`form-group ${
                    triggered && sellerDetails?.occupation === "" ? "" : "mb-3"
                  }`}
                >
                  <label className="mb-1">
                    <strong>{t("occupationInput")}</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t("occupationInput")}
                    className="form-control"
                    value={sellerDetails?.occupation}
                    onChange={(e) =>
                      updateSellerDetails("occupation", e.target.value)
                    }
                  />
                </div>
                {triggered && sellerDetails?.occupation === "" && (
                  <div className="text-danger fs-12 mb-3">
                    {t("occupationInput")} {t("globalIsRequired")}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("addressInput")}</strong>
                  </label>
                  <StandaloneSearchBox
                    onLoad={(ref) => (searchBoxRef.current = ref)}
                    onPlacesChanged={handlePlacesChanged}
                  >
                    <input
                      type="text"
                      placeholder={t("addressInput")}
                      className="form-control"
                      value={addressInput}
                      onChange={(e) => {
                        const newAddress = e.target.value;
                        setAddressInput(newAddress);
                        updateSellerDetails("address", newAddress);
                        updateSellerDetails("city", "");
                        updateSellerDetails("region", "");
                        updateSellerDetails("postalCode", "");
                        updateSellerDetails("country", "");
                      }}
                    />
                  </StandaloneSearchBox>
                </div>
              </div>
              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("cityInput")}</strong>
                  </label>
                  <input
                    type="text"
                    placeholder={t("cityInput")}
                    className="form-control"
                    value={sellerDetails?.city}
                    onChange={(e) =>
                      updateSellerDetails("city", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("regionInput")}</strong>
                  </label>
                  <input
                    type="text"
                    placeholder={t("regionInput")}
                    className="form-control"
                    value={sellerDetails?.region}
                    onChange={(e) =>
                      updateSellerDetails("region", e.target.value)
                    }
                  />
                  {/* <select
                    className="form-control"
                    style={{ border: "1px solid #EEEEEE" }}
                    value={sellerDetails?.region}
                    onChange={(e) =>
                      updateSellerDetails("region", e.target.value)
                    }
                  >
                    <option value="">{t("globalSelect")}</option>
                    <option value="Alberta">{t("halberta")}</option>
                    <option value="British Columbia">
                      {t("hbritishcolumbia")}
                    </option>
                    <option value="Manitoba">{t("hmanitoba")}</option>
                    <option value="New Brunswick">{t("hnewbrunswick")}</option>
                    <option value="Newfoundland and Labrador">
                      {t("hnewfoundland")}
                    </option>
                    <option value="Northwest Territories">
                      {t("hnorthwestterritories")}
                    </option>
                    <option value="Nova Scotia">{t("hnovascotia")}</option>
                    <option value="Nunavut">{t("hnunavut")}</option>
                    <option value="Ontario">{t("hontario")}</option>
                    <option value="Prince Edward Island">{t("hpei")}</option>
                    <option value="Quebec">{t("hquebec")}</option>
                    <option value="Saskatchewan">{t("hsaskatchewan")}</option>
                    <option value="Yukon">{t("hyukon")}</option>
                  </select> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("postalCodeInput")}</strong>
                  </label>
                  <input
                    type="number"
                    placeholder={t("postalCodeInput")}
                    className="form-control"
                    value={sellerDetails?.postalCode}
                    onChange={(e) =>
                      updateSellerDetails("postalCode", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-4 col-xl-4">
                <div
                  className={`form-group ${
                    triggered && sellerDetails?.country === "" ? "" : "mb-3"
                  }`}
                >
                  <label className="mb-1">
                    <strong>{t("countryInput")}</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t("countryInput")}
                    className="form-control"
                    value={sellerDetails?.country}
                    onChange={(e) =>
                      updateSellerDetails("country", e.target.value)
                    }
                  />
                </div>
                {triggered && sellerDetails?.country === "" && (
                  <div className="text-danger fs-12 mb-3">
                    {t("countryInput")} {t("globalIsRequired")}
                  </div>
                )}
              </div>

              <div className="col-sm-12 col-md-4 col-xl-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("websiteInput")}</strong>
                  </label>
                  <input
                    type="text"
                    placeholder={t("websiteInput")}
                    className="form-control"
                    value={sellerDetails?.website}
                    onChange={(e) =>
                      updateSellerDetails("website", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="mb-1">
                  <strong>{t("photoInput")}</strong>
                </label>
                <input
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  className="form-control"
                  ref={fileInputRef}
                  onChange={onChangePhoto}
                />
              </div>

              <div className="col-md-3">
                <label className="mb-1 d-block">
                  <strong>{t("needProfessionalServiceInput")}</strong>
                </label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="need_professionals"
                    id="needProfessionalServiceYes"
                    value={true}
                    checked={sellerDetails?.need_professionals == "true"}
                    onChange={(e) =>
                      updateSellerDetails("need_professionals", e.target.value)
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="needProfessionalServiceYes"
                  >
                    {t("yesOption")}
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="need_professionals"
                    id="needProfessionalServiceNo"
                    value={false}
                    checked={sellerDetails?.need_professionals === "false"}
                    onChange={(e) =>
                      updateSellerDetails("need_professionals", e.target.value)
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="needProfessionalServiceNo"
                  >
                    {t("noOption")}
                  </label>
                </div>
              </div>
              {sellerDetails?.need_professionals === "true" && (
                <div className="col-md-12 col-lg-3 col-xl-3 ">
                  <div
                    className={`form-group ${
                      triggered && sellerDetails?.region === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("professionalsDomain")}</strong>
                    </label>

                    <MultiSelect
                      options={[
                        {
                          label: t("hbroker"),
                          value: "Real Estate Broker",
                        },
                        {
                          label: t("hbrokerFinance"),
                          value: "Finance Broker",
                        },
                        { label: t("hlawyer"), value: "Lawyer" },
                        { label: t("hfiscaliste"), value: "Fiscalist" },
                      ]}
                      value={professions}
                      onChange={setProfessions}
                      labelledBy="Select"
                    />
                  </div>
                </div>
              )}
            </div>
            <div
              className="h4"
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginTop: "30px",
                paddingTop: "10px",
                backgroundColor: "#310247",
              }}
            >
              <h4 style={{ color: "#ffffffff", marginLeft: "10px" }}>
                {t("hOtherInformation")}
              </h4>
              <hr />
            </div>

            <div className="row">
              {/* Ownership Type */}
              <div className="col-md-12 col-lg-12 col-xl-12">
                <label className="mb-2">
                  <strong>{t("htypeSeller")}</strong>
                </label>
                <select
                  className="form-control"
                  value={ownershipType}
                  onChange={(e) => setOwnershipType(e.target.value)}
                >
                  <option value="single">{t("honlypartner")}</option>
                  <option value="partner">{t("hmultiplepartner")}</option>
                </select>
              </div>

              {ownershipType === "partner" && (
                <div className="col-md-12 mt-3">
                  <h5>{t("hpartner")}</h5>
                  {partners.map((partner, idx) => (
                    <div className="row mb-2" key={idx}>
                      <div className="col-md-4">
                        <input
                          type="text"
                          placeholder="Partner Name"
                          className="form-control"
                          value={partner.partner_name}
                          onChange={(e) =>
                            updatePartner(idx, "partner_name", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          placeholder="Partner Email"
                          className="form-control"
                          value={partner.partner_email}
                          onChange={(e) =>
                            updatePartner(idx, "partner_email", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <div className="input-group">
                          <input
                            type="number"
                            min="0"
                            max="100"
                            placeholder="% Ownership"
                            className="form-control"
                            value={partner.partnership_percentage}
                            onChange={(e) =>
                              updatePartner(
                                idx,
                                "partnership_percentage",
                                e.target.value
                              )
                            }
                          />
                          <div
                            className="form-control input-group-text custom-group-text"
                            style={{}}
                          >
                            {" "}
                            %{" "}
                          </div>
                        </div>
                      </div>
                      {idx !== partners.length - 1 && (
                        <div className="col-md-2  d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => removePartner(idx)}
                          >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      )}
                      {idx === partners.length - 1 && (
                        <div className="col-md-2  d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={addPartner}
                          >
                            {" "}
                            +{" "}
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                  {totalOwnership > 100 && (
                    <div className="text-danger">{t("hcannotexceed")} </div>
                  )}
                </div>
              )}
            </div>
            <div className="row mt-3">
              <div className="col-sm-12 col-md-6">
                <label>
                  {" "}
                  <strong>{t("hequityCapital")}</strong>
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    className="form-control"
                    placeholder="Equity (%)"
                    value={equity}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "") {
                        setEquity("");
                        return;
                      }
                      const num = Math.max(0, Math.min(100, parseFloat(val)));
                      setEquity(Number.isNaN(num) ? "" : num);
                    }}
                  />
                  <div className="form-control input-group-text custom-group-text">
                    %
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <label>
                  <strong>{t("hloansQuestion")}</strong>
                </label>
                <select
                  className="form-control"
                  value={loan ? "yes" : "no"}
                  onChange={(e) => setLoan(e.target.value === "yes")}
                >
                  <option value="no">{t("hno")}</option>
                  <option value="yes">{t("hyes")}</option>
                </select>
              </div>

              {loan && (
                <div className="row mt-2">
                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Financial Institution"
                      className="form-control"
                      value={loanDetails.institution}
                      onChange={(e) =>
                        setLoanDetails({
                          ...loanDetails,
                          institution: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="number"
                      placeholder="Loan Balance"
                      className="form-control"
                      value={loanDetails.balance}
                      onChange={(e) =>
                        setLoanDetails({
                          ...loanDetails,
                          balance: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div
                  className={`form-group ${
                    triggered &&
                    (shortTermDebtAmount === "" ||
                      Number(shortTermDebtAmount) < 0 ||
                      Number.isNaN(Number(shortTermDebtAmount)))
                      ? "mb-1"
                      : "mb-3"
                  }`}
                >
                  <label className="mb-1">
                    <strong>Short-term Debt Amount</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    className="form-control"
                    placeholder="Short-term debt value"
                    value={shortTermDebtAmount}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (v === "") return setShortTermDebtAmount("");
                      const n = Number(v);
                      if (Number.isNaN(n)) return setShortTermDebtAmount("");
                      if (n < 0) return setShortTermDebtAmount("0");
                      setShortTermDebtAmount(v);
                    }}
                  />
                </div>
                {triggered && shortTermDebtAmount === "" && (
                  <div className="text-danger fs-12 mb-3">
                    Short-term Debt Amount is required
                  </div>
                )}
                {triggered && Number(shortTermDebtAmount) < 0 && (
                  <div className="text-danger fs-12 mb-3">
                    Short-term Debt Amount must be 0 or greater
                  </div>
                )}

                <div
                  className={`form-group ${
                    triggered &&
                    (longTermDebtAmount === "" ||
                      Number(longTermDebtAmount) < 0 ||
                      Number.isNaN(Number(longTermDebtAmount)))
                      ? "mb-1"
                      : "mb-3"
                  }`}
                >
                  <label className="mb-1">
                    <strong>Long-term Debt Amount</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    className="form-control"
                    placeholder="Long-term debt value"
                    value={longTermDebtAmount}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (v === "") return setLongTermDebtAmount("");
                      const n = Number(v);
                      if (Number.isNaN(n)) return setLongTermDebtAmount("");
                      if (n < 0) return setLongTermDebtAmount("0");
                      setLongTermDebtAmount(v);
                    }}
                  />
                </div>
                {triggered && longTermDebtAmount === "" && (
                  <div className="text-danger fs-12 mb-3">
                    Long-term Debt Amount is required
                  </div>
                )}
                {triggered && Number(longTermDebtAmount) < 0 && (
                  <div className="text-danger fs-12 mb-3">
                    Long-term Debt Amount must be 0 or greater
                  </div>
                )}
              </div>
              <div className="col-md-6 col-sm-12">
                <label>
                  <strong>{t("hcreditor")}</strong>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Creditor Name / Institution"
                  value={creditor}
                  onChange={(e) => setCreditor(e.target.value)}
                />
              </div>
              <div className="row mt-2">
                <div className="col-12">
                  <label>
                    <strong>Funding Rounds</strong>
                  </label>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div
                    className={`form-group ${
                      triggered &&
                      (fundingRounds.seed === "" ||
                        Number(fundingRounds.seed) < 0 ||
                        Number.isNaN(Number(fundingRounds.seed)))
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>Seed Amount</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="form-control"
                      placeholder="Seed amount"
                      value={fundingRounds.seed}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v === "")
                          return setFundingRounds({
                            ...fundingRounds,
                            seed: "",
                          });
                        const n = Number(v);
                        if (Number.isNaN(n))
                          return setFundingRounds({
                            ...fundingRounds,
                            seed: "",
                          });
                        if (n < 0)
                          return setFundingRounds({
                            ...fundingRounds,
                            seed: "0",
                          });
                        setFundingRounds({ ...fundingRounds, seed: v });
                      }}
                    />
                  </div>
                  {triggered && fundingRounds.seed === "" && (
                    <div className="text-danger fs-12 mb-3">
                      Seed Amount is required
                    </div>
                  )}
                  {triggered && Number(fundingRounds.seed) < 0 && (
                    <div className="text-danger fs-12 mb-3">
                      Seed Amount must be 0 or greater
                    </div>
                  )}
                </div>
                <div className="col-md-6 col-sm-6">
                  <div
                    className={`form-group ${
                      triggered &&
                      (fundingRounds.a === "" ||
                        Number(fundingRounds.a) < 0 ||
                        Number.isNaN(Number(fundingRounds.a)))
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>Series A Amount</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="form-control"
                      placeholder="Series A amount"
                      value={fundingRounds.a}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v === "")
                          return setFundingRounds({
                            ...fundingRounds,
                            a: "",
                          });
                        const n = Number(v);
                        if (Number.isNaN(n))
                          return setFundingRounds({
                            ...fundingRounds,
                            a: "",
                          });
                        if (n < 0)
                          return setFundingRounds({
                            ...fundingRounds,
                            a: "0",
                          });
                        setFundingRounds({ ...fundingRounds, a: v });
                      }}
                    />
                  </div>
                  {triggered && fundingRounds.a === "" && (
                    <div className="text-danger fs-12 mb-3">
                      Series A Amount is required
                    </div>
                  )}
                  {triggered && Number(fundingRounds.a) < 0 && (
                    <div className="text-danger fs-12 mb-3">
                      Series A Amount must be 0 or greater
                    </div>
                  )}
                </div>
                <div className="col-md-6 col-sm-6">
                  <div
                    className={`form-group ${
                      triggered &&
                      (fundingRounds.b === "" ||
                        Number(fundingRounds.b) < 0 ||
                        Number.isNaN(Number(fundingRounds.b)))
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>Series B Amount</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="form-control"
                      placeholder="Series B amount"
                      value={fundingRounds.b}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v === "")
                          return setFundingRounds({
                            ...fundingRounds,
                            b: "",
                          });
                        const n = Number(v);
                        if (Number.isNaN(n))
                          return setFundingRounds({
                            ...fundingRounds,
                            b: "",
                          });
                        if (n < 0)
                          return setFundingRounds({
                            ...fundingRounds,
                            b: "0",
                          });
                        setFundingRounds({ ...fundingRounds, b: v });
                      }}
                    />
                  </div>
                  {triggered && fundingRounds.b === "" && (
                    <div className="text-danger fs-12 mb-3">
                      Series B Amount is required
                    </div>
                  )}
                  {triggered && Number(fundingRounds.b) < 0 && (
                    <div className="text-danger fs-12 mb-3">
                      Series B Amount must be 0 or greater
                    </div>
                  )}
                </div>
                <div className="col-md-6 col-sm-6">
                  <div
                    className={`form-group ${
                      triggered &&
                      (fundingRounds.c === "" ||
                        Number(fundingRounds.c) < 0 ||
                        Number.isNaN(Number(fundingRounds.c)))
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>Series C Amount</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="form-control"
                      placeholder="Series C amount"
                      value={fundingRounds.c}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v === "")
                          return setFundingRounds({
                            ...fundingRounds,
                            c: "",
                          });
                        const n = Number(v);
                        if (Number.isNaN(n))
                          return setFundingRounds({
                            ...fundingRounds,
                            c: "",
                          });
                        if (n < 0)
                          return setFundingRounds({
                            ...fundingRounds,
                            c: "0",
                          });
                        setFundingRounds({ ...fundingRounds, c: v });
                      }}
                    />
                  </div>
                  {triggered && fundingRounds.c === "" && (
                    <div className="text-danger fs-12 mb-3">
                      Series C Amount is required
                    </div>
                  )}
                  {triggered && Number(fundingRounds.c) < 0 && (
                    <div className="text-danger fs-12 mb-3">
                      Series C Amount must be 0 or greater
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginTop: "30px",
                paddingTop: "15px",
                backgroundColor: "#310247",
              }}
            >
              <h4 style={{ color: "#ffffff", marginLeft: "10px" }}>
                {t("hcontactInfos")}
              </h4>
              <hr />
            </div>

            <div className="row">
              <div className="col-md-4 col-sm-12 col-xl-4">
                <div
                  className={`form-group ${
                    triggered && sellerDetails?.contactName === ""
                      ? "mb-1"
                      : "mb-3"
                  }`}
                >
                  <label className="mb-1">
                    <strong>{t("contactNameInput")}</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t("contactNameInput")}
                    className="form-control"
                    value={sellerDetails?.contactName}
                    onChange={(e) =>
                      updateSellerDetails("contactName", e.target.value)
                    }
                  />
                </div>
                {triggered && sellerDetails?.contactName === "" && (
                  <div className="text-danger fs-12 mb-3">
                    {" "}
                    {t("contactNameInput")} {t("globalIsRequired")}
                  </div>
                )}
              </div>

              <div className="col-md-4 col-sm-12 col-xl-4">
                <div
                  className={`form-group ${
                    triggered && sellerDetails?.contactEmail === ""
                      ? "mb-1"
                      : "mb-3"
                  }`}
                >
                  <label className="mb-1">
                    <strong>{t("contactEmailInput")}</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder={t("contactEmailInput")}
                    className="form-control"
                    value={sellerDetails?.contactEmail}
                    onChange={(e) =>
                      updateSellerDetails("contactEmail", e.target.value)
                    }
                  />
                </div>
                {triggered && sellerDetails?.contactEmail === "" && (
                  <div className="text-danger fs-12 mb-3">
                    {t("contactEmailInput")} {t("globalIsRequired")}
                  </div>
                )}
              </div>
              <div className="col-md-4 col-sm-12 col-xl-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("secondaryPhoneInput")}</strong>
                  </label>
                  <input
                    type="number"
                    placeholder={t("secondaryPhoneInput")}
                    className="form-control"
                    value={sellerDetails?.phone2}
                    onChange={(e) =>
                      updateSellerDetails("phone2", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-5">
              {updateSeller.cond ? (
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => addSellerHandler(updateSeller.id)}
                  >
                    {t("saveButton")}
                  </button>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => addSellerHandler(null)}
                  >
                    {t("saveButton")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CreateSeller;
